import { Constants } from './../../shared/constants';
import { FlashMessagesService } from './../../shared/flash-messages/service/flash.messages.service';
import { Injectable } from '@angular/core';
import { Payment } from '../models/payment';
import { Observable } from 'rxjs/Observable';
import { RequestOptions, Headers, Response } from '@angular/http';
import { List } from 'immutable';
import { EnvironmentConfiguration } from '../../environment/services/environment.configuration';
import { ResponseUtilService } from '../../shared/utils/response-util.service';
import { AppAuthHttpService } from '../../http/app.auth.http.service';

@Injectable()
export class OoivRulesHttpService {
  private eventsOOIVGetUrl: string = this.environment.baseUrl + '/api/events/ooiv';

  constructor(private http: AppAuthHttpService,
              private environment: EnvironmentConfiguration,
              private responseUtilService: ResponseUtilService) {
  }

  getOoivRules(eventId: number): Observable<any> {
    return this.http.get(`${this.eventsOOIVGetUrl}/${eventId}/rules`)
      .map(response => response.json())
      .catch(response => this.responseUtilService.handleError(response)).share();
  }

}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/service/ooiv-rules.http.service.ts